/** Indices of calibrated grid lines that intersect the image extent. */
export function gridLineIndexRange(length: number, offset: number, spacing: number) {
    const first = Math.ceil(-offset / spacing);
    const last = Math.floor((length - offset) / spacing);
    return {
        first: first || 0,
        last: last || 0,
    };
}
